import { Signal } from '@angular/core';
import { MetaObject } from '@softline/dynamic';

export abstract class MetaBaseDirective<T> {
  abstract metaObject: Signal<MetaObject<T> | null>;
}
